import { render, staticRenderFns } from "./IdeasPage.vue?vue&type=template&id=2600c82b&scoped=true&"
import script from "./IdeasPage.vue?vue&type=script&lang=js&"
export * from "./IdeasPage.vue?vue&type=script&lang=js&"
import style0 from "./IdeasPage.vue?vue&type=style&index=0&id=2600c82b&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2600c82b",
  null
  
)

export default component.exports